<template>
  <section class="labeling container">
    <nav>
      <button v-if="!expanded" class="hb" @click="expanded = true">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
        </svg>
      </button>
      <button v-else class="hb" @click="expanded = false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="24px" height="24px">
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path d="M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z" />
        </svg>
      </button>
      <ul class="nav-list" :class="{ expanded }">
        <li v-for="item of nav" :key="item.url" class="nav-list-item" @click="expanded = false">
          <router-link :to="item.url">{{ item.title }} </router-link>
        </li>
        <li class="nav-list-item back" @click="expanded = false">
          <yn-button color="primary" variant="text" @click="$router.push(`/topics`)">Management</yn-button>
        </li>
      </ul>
    </nav>
    <router-view></router-view>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';

export default {
  components: {
    'yn-button': Button
  },
  meta: {
    title: 'Home'
  },
  data() {
    return {
      isReady: false,
      expanded: false,
      nav: [
        {
          title: 'Home',
          url: `/`
        },
        {
          title: 'Topic search',
          url: `/search`
        }
      ]
    };
  },
  computed: {
    ...mapState({
      currentIdentity: s => s.identity.email,
      collection: s => s.labelling.collection,
      isGetRequestPending: s => s.labelling.isGetCollectionPending
    })
  }
};
</script>

<style scoped lang="scss">
.labeling {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  position: relative;

  .hb {
    border: 0;
    outline: none;

    position: absolute;
    z-index: 10;
  }

  nav {
    width: 250px;
    padding: 2rem 3rem 2rem 0;
    .nav-list {
      list-style: none;
    }

    .nav-list-item {
      // border: 1px solid #e1e1e1;
      a {
        width: 100%;
        display: flex;
        align-items: center;
        color: #2d313d;
        padding: 1rem 2rem;
        font-size: 0.85rem;
        font-weight: 700;
        border-radius: 28px;
        text-transform: uppercase;
      }
      a.router-link-exact-active {
        background-color: #2d313d;
        color: #fff;
      }

      &.back {
        padding: 2rem;

        display: flex;
        button {
          padding-left: 0;
        }
      }
    }
  }

  .hb {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    .hb {
      display: block;
    }
    nav {
      width: 0;
    }
    .nav-list {
      position: absolute;
      width: 0;
      overflow: hidden;
      &.expanded {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #fff;
        padding: 1.25rem 3rem 2rem 3rem;
        z-index: 1;
      }
    }
  }
}
</style>
